(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-category-bar"] && !Shopify.designMode) return;
  try {
    
  class BMCategoryBar {
    constructor(root) {
      this.root = root;
      this.open = null;
      this.hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      this.sets = new Map();
      root.querySelectorAll('[data-bm-catbar-set]').forEach((set) => {
        this.sets.set(set.dataset.setLabel, set);
      });

      this.onToggle = this.onToggle.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onFocusOut = this.onFocusOut.bind(this);
      this.onPointerLeave = this.onPointerLeave.bind(this);

      root.addEventListener('click', this.onToggle);
      root.addEventListener('keydown', this.onKeydown);
      root.addEventListener('focusout', this.onFocusOut);
      root.addEventListener('pointerleave', this.onPointerLeave);

      if (this.hoverCapable) {
        root.querySelectorAll('[data-bm-catbar-toggle]').forEach((button) => {
          button.addEventListener('pointerenter', () => this.show(button));
        });
      }

      this.bindNav();
    }

    bindNav() {
      const selector = this.root.dataset.navSelector;
      if (!selector || this.sets.size < 2) return;

      const blocked = (this.root.dataset.noNavigate || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);

      let links;
      try {
        links = document.querySelectorAll(selector);
      } catch (error) {
        return;
      }

      links.forEach((link) => {
        const label = (link.textContent || '').trim().toLowerCase();
        if (!this.sets.has(label)) return;

        const activate = () => this.activateSet(label);
        link.addEventListener('pointerenter', activate);
        link.addEventListener('focus', activate);

        if (blocked.includes(label)) {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            activate();
          });
        }
      });
    }

    activateSet(label) {
      const target = this.sets.get(label);
      if (!target || !target.hidden) return;

      this.hide();
      this.sets.forEach((set) => {
        set.hidden = set !== target;
      });
    }

    panelFor(button) {
      return this.root.querySelector('#' + CSS.escape(button.getAttribute('aria-controls')));
    }

    show(button) {
      if (this.open === button) return;
      this.hide();

      const panel = this.panelFor(button);
      if (!panel) return;

      button.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      this.open = button;
    }

    hide() {
      if (!this.open) return;

      const panel = this.panelFor(this.open);
      if (panel) panel.hidden = true;

      this.open.setAttribute('aria-expanded', 'false');
      this.open = null;
    }

    onToggle(event) {
      const button = event.target.closest('[data-bm-catbar-toggle]');
      if (!button) return;

      event.preventDefault();
      if (this.open === button) {
        this.hide();
      } else {
        this.show(button);
      }
    }

    onKeydown(event) {
      if (event.key !== 'Escape' || !this.open) return;

      const button = this.open;
      this.hide();
      button.focus();
    }

    onFocusOut(event) {
      if (!this.open) return;
      if (this.root.contains(event.relatedTarget)) return;
      this.hide();
    }

    onPointerLeave() {
      if (this.hoverCapable) this.hide();
    }
  }

  function bmInitCategoryBars(scope) {
    (scope || document).querySelectorAll('[data-bm-catbar]').forEach((root) => {
      if (!root.bmCategoryBar) root.bmCategoryBar = new BMCategoryBar(root);
    });
  }

  bmInitCategoryBars(document);

  document.addEventListener('shopify:section:load', (event) => bmInitCategoryBars(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-drop-countdown"] && !Shopify.designMode) return;
  try {
    
  class BMDropCountdown {
    constructor(root) {
      this.root = root;
      this.target = Date.parse(root.dataset.launchAt);
      this.endedText = root.dataset.endedText || 'Live now';
      this.values = {};

      root.querySelectorAll('[data-unit]').forEach((node) => {
        this.values[node.dataset.unit] = node;
      });

      if (Number.isNaN(this.target)) {
        this.showEnded();
        return;
      }

      this.tick();
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    tick() {
      const remaining = this.target - Date.now();

      if (remaining <= 0) {
        this.showEnded();
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);

      this.set('days', Math.floor(totalSeconds / 86400));
      this.set('hours', Math.floor(totalSeconds / 3600) % 24);
      this.set('minutes', Math.floor(totalSeconds / 60) % 60);
      this.set('seconds', totalSeconds % 60);
    }

    set(unit, value) {
      const node = this.values[unit];
      if (!node) return;

      const next = String(value).padStart(2, '0');
      if (node.textContent !== next) node.textContent = next;
    }

    showEnded() {
      window.clearInterval(this.timer);
      this.root.setAttribute('data-ended', '');
      this.root.removeAttribute('aria-hidden');

      if (this.values.days) this.values.days.textContent = this.endedText;
    }

    disconnect() {
      window.clearInterval(this.timer);
    }
  }

  function bmInitCountdowns(scope) {
    (scope || document).querySelectorAll('[data-bm-countdown]').forEach((root) => {
      if (root.bmCountdown) root.bmCountdown.disconnect();
      root.bmCountdown = new BMDropCountdown(root);
    });
  }

  bmInitCountdowns(document);

  document.addEventListener('shopify:section:load', (event) => bmInitCountdowns(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-bm-countdown]').forEach((root) => {
      if (root.bmCountdown) root.bmCountdown.disconnect();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-hero-product"] && !Shopify.designMode) return;
  try {
    
  // Only the horizontal mode needs a script. Vertical is sticky CSS on its own.
  class BMAnchorProduct {
    constructor(root) {
      this.root = root;
      this.aside = root.querySelector('.bm-anchor__aside');
      this.count = Number(getComputedStyle(root).getPropertyValue('--bm-anchor-count')) || 1;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
    }

    connect() {
      if (!this.aside || this.count < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.desktop.addEventListener('change', this.onScroll);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        if (!this.desktop.matches) {
          this.root.style.removeProperty('--bm-anchor-progress');
          return;
        }
        const box = this.aside.getBoundingClientRect();
        const travel = box.height - window.innerHeight;
        if (travel <= 0) return;
        const ratio = Math.min(Math.max(-box.top / travel, 0), 1);
        this.root.style.setProperty(
          '--bm-anchor-progress',
          (ratio * (this.count - 1)).toFixed(4)
        );
      });
    }
  }

  document.querySelectorAll('.bm-anchor--horizontal').forEach((root) => {
    new BMAnchorProduct(root).connect();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-set-buy"] && !Shopify.designMode) return;
  try {
    
  class BMSetBuy {
    constructor(root) {
      this.root = root;
      this.data = JSON.parse(root.querySelector('[data-bm-set-variants]').textContent);
      this.sizeName = root.dataset.sizeOption;
      this.colourName = root.dataset.colourOption;
      this.names = this.data.optionNames;
      this.submit = root.querySelector('[data-bm-set-submit]');
      this.topInput = root.querySelector('[data-bm-set-top-variant]');
      this.note = root.querySelector('[data-bm-set-note]');
      this.price = root.querySelector('[data-bm-set-price]');
      this.colourLabel = root.querySelector('[data-bm-set-colour-label]');
      // Once she picks a bottom size herself we stop suggesting one.
      this.bottomTouched = false;
    }

    optionIndex(name) {
      return this.names.indexOf(name);
    }

    find(part, colour, size) {
      const ci = this.optionIndex(this.colourName);
      const si = this.optionIndex(this.sizeName);
      return this.data[part].variants.find(
        (v) => v.options[ci] === colour && v.options[si] === size
      );
    }

    get colour() {
      return this.root.querySelector('[data-bm-set-colour]:checked')?.value ?? null;
    }

    size(part) {
      return this.root.querySelector(`[data-bm-set-size="${part}"]:checked`)?.value ?? null;
    }

    connect() {
      this.root.addEventListener('change', (event) => {
        const target = event.target;
        if (target.matches('[data-bm-set-colour]')) {
          if (this.colourLabel) this.colourLabel.textContent = target.value;
          this.bottomTouched = false;
        }
        if (target.matches('[data-bm-set-size="bottom"]')) this.bottomTouched = true;
        if (target.matches('[data-bm-set-size="top"]')) this.suggestBottom();
        this.refresh();
      });

      this.submit?.addEventListener('click', (event) => this.addSet(event));
      this.refresh();
    }

    // Same size on both is only a default. It is applied once, only when that
    // size actually exists and is in stock, and never after she has chosen.
    suggestBottom() {
      if (this.bottomTouched) return;
      const size = this.size('top');
      const match = this.find('bottom', this.colour, size);
      if (!match?.available) return;
      const input = this.root.querySelector(
        `[data-bm-set-size="bottom"][value="${CSS.escape(size)}"]`
      );
      if (input && !input.disabled) input.checked = true;
    }

    refresh() {
      const colour = this.colour;

      // Grey out sizes with no stock in the chosen colour, per product.
      for (const part of ['top', 'bottom']) {
        for (const input of this.root.querySelectorAll(`[data-bm-set-size="${part}"]`)) {
          const variant = this.find(part, colour, input.value);
          input.disabled = !variant?.available;
          if (input.disabled && input.checked) input.checked = false;
        }
      }

      const top = this.find('top', colour, this.size('top'));
      const bottom = this.find('bottom', colour, this.size('bottom'));
      const ready = Boolean(top?.available && bottom?.available);

      if (this.submit) this.submit.disabled = !ready;
      if (this.topInput) this.topInput.value = ready ? String(top.id) : '';
      this.bottomId = ready ? bottom.id : null;

      if (this.price && ready) {
        this.price.textContent = this.money(top.price + bottom.price);
      }

      // Only complain once she has asked for a combination that cannot be built.
      const asked = this.size('top') && this.size('bottom');
      if (this.note) this.note.hidden = !(asked && !ready);
    }

    money(cents) {
      const format = window.Shopify?.currency?.active ?? 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: format,
        }).format(cents / 100);
      } catch {
        return `$${(cents / 100).toFixed(2)}`;
      }
    }

    // The bottom goes in quietly first; the top then goes through Horizon's own
    // form component, whose event is what opens the drawer with both lines.
    async addSet(event) {
      if (!this.bottomId) return;
      event.preventDefault();
      this.submit.disabled = true;
      try {
        await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: this.bottomId, quantity: 1 }] }),
        });
      } catch {
        // If the quiet add fails, fall through: the top still gets added and
        // the drawer still opens, so she sees what did make it in.
      }
      this.submit.disabled = false;
      this.submit.closest('form')?.requestSubmit();
    }
  }

  document.querySelectorAll('.bm-set').forEach((root) => {
    if (root.querySelector('[data-bm-set-variants]')) new BMSetBuy(root).connect();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
